module.exports = __webpack_public_path__ + "static/media/zaakfield_kimihurura4.97ccd61e.jpg";